import { useEffect } from 'react'

export function usePerformance() {
  useEffect(() => {
    // 성능 메트릭 수집
    if ('performance' in window && 'PerformanceObserver' in window) {
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.entryType === 'navigation') {
            const navEntry = entry as PerformanceNavigationTiming
            console.log('Page Load Time:', navEntry.loadEventEnd - navEntry.fetchStart, 'ms')
          }
        }
      })

      observer.observe({ entryTypes: ['navigation', 'resource'] })

      return () => observer.disconnect()
    }
  }, [])
}

